import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth, db } from "../firebase";
import { doc, getDoc, getDocs, query, collection, where } from "firebase/firestore";
import "./../App.css"

function Menu() {
    const [username, setUsername] = useState("Guest");
    const [userData, setUserData] = useState(null);
    const [propertyStatus, setPropertyStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [propertyName, setPropertyName] = useState("");
    const [propertyLogo, setPropertyLogo] = useState("");
    const [documentStatus, setDocumentStatus] = useState(null);

    const [openMenu, setOpenMenu] = useState(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                if (!userData) return;

                const userRef = doc(db, "authroles", userData.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    const user = userSnap.data();
                    setUsername(user.name || "Guest");

                    if (user.propertyId) {
                        fetchPropertyAndDocuments(user.propertyId);
                        fetchPropertyDetails(user.propertyId);
                    } else {
                        setDocumentStatus("pending");
                        setPropertyStatus("no-property");
                    }

                }

                setLoading(false);
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, [userData]);

    const fetchPropertyDetails = async (propertyId) => {
        try {
            const propRef = doc(db, "properties", propertyId);
            const propSnap = await getDoc(propRef);

            if (propSnap.exists()) {
                const propData = propSnap.data();

                setPropertyStatus(propData.status || null);
                setPropertyName(propData.hotelname || "");
                setPropertyLogo(propData.logo || "");

                if (propData.status === "Deactivate") {
                    window.location.href = "/disabled-property";
                    return;
                }
            } else {
                setPropertyStatus("not-found");
            }
        } catch (err) {
            console.error("Error fetching property:", err);
        }
    };

    const fetchPropertyAndDocuments = async (propertyId) => {
        try {
            /* ---------- PROPERTY ---------- */
            const propRef = doc(db, "properties", propertyId);
            const propSnap = await getDoc(propRef);

            if (propSnap.exists()) {
                const propData = propSnap.data();
                setPropertyName(propData.hotelname || "");
                setPropertyLogo(propData.logo || "");

                if (propData.status === "Deactivate") {
                    window.location.href = "/disabled-property";
                    return;
                }
            }

            /* ---------- DOCUMENTS ---------- */
            const docsQuery = query(
                collection(db, "documents"),
                where("propertyId", "==", propertyId)
            );


            const docsSnap = await getDocs(docsQuery);

            if (!docsSnap.empty) {
                const docsData = docsSnap.docs[0].data();
                setDocumentStatus(docsData.status); // ✅ approved / pending / rejected
            } else {
                setDocumentStatus("pending");
            }

        } catch (err) {
            console.error("Error fetching property/documents:", err);
            setDocumentStatus("pending");
        } finally {
            setLoading(false);
        }
    };


    // ------------------------------
    //   STYLES
    // ------------------------------

    const linkStyle = {
        color: "#fff",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "15px 15px",
        borderRadius: "8px",
        transition: "all 0.3s ease",
        textDecoration: "none",
        borderBottom: "1px solid rgba(245, 238, 238, 0.2)",
        cursor: "pointer",
        position: "relative"
    };

    const linkHover = {
        background: "rgba(255,255,255,0.15)",
        transform: "translateX(6px)"
    };

    const submenuStyle = {
        paddingLeft: "25px",
        background: "rgba(255,255,255,0.07)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
        display: "block"
    };

    const iconStyle = {
        fontSize: "20px",
        width: "45px",
        textAlign: "center"
    };

    const arrowIconStyle = {
        marginLeft: "auto",
        transition: "0.3s",
        fontSize: "14px"
    };

    const firstLetter = username.charAt(0).toUpperCase();

    // ------------------------------
    //   MENU STRUCTURE
    // ------------------------------


    const propertyMenu = {
        icon: "fas fa-hotel",
        text: "Property",
        submenu: [
            { text: "Property Details", link: "/property-details" },
            { text: "Upload Documents", link: "/property-documents" },
            { text: "Room Facilities", link: "/room-facilities" },
            { text: "Amenities", link: "/amenties" },
            { text: "Rules & Regulations", link: "/rules-and-regulations" }
        ]
    };

    const fullMenu = [
        { icon: "fas fa-tachometer-alt", text: "Home", link: "/home" },
        // { icon: "fas fa-clipboard-check", text: "Approvals", link: "/approvals" },
        {
            icon: "fas fa-concierge-bell",
            text: "Reservations",
            submenu: [
                { text: "Reserve Room", link: "/reservation" },
                { text: "Live Reservations", link: "/live-reservations" },
                { text: "Checkouts", link: "/checkouts" },
                { text: "Damage Notes", link: "/damage-notes" },
                { text: "Pending Payments", link: "/pending-payments" },
                { text: "Pending Reservations", link: "/pending-reservations" },
            ]
        },

        // {
        //     icon: "fas fa-globe", // Modern globe icon representing "Online" connectivity
        //     text: "Online Bookings",
        //     submenu: [
        //         { text: "OTA Bookings", link: "/ota-bookings" },

        //     ]
        // },

        {
            icon: "fas fa-broom",
            text: "Cleaning",
            submenu: [
                { text: "Cleaning Rooms", link: "/cleaning-rooms" },
                { text: "Cleaned Rooms", link: "/cleaned-rooms" },
            ]
        },

        {
            icon: "fas fa-chart-pie",
            text: "Report",
            submenu: [
                { text: "DCR Report", link: "/dcr-report" },
                { text: "Datewise Bookings", link: "/datewise-bookings" },
                { text: "Receptionist Report", link: "/receptionist-report" },
                { text: "Paymodewise Report", link: "/paymodewise-report" },
                { text: "Roomtypewise Online ", link: "/roomtypewise-report" },
                { text: "Booking Type Wise Report", link: "/booking-typewise-report" },
                { text: "Checkout Alert", link: "/checkout-alert" },
                { text: "Website Enquiries", link: "/website-enquiries" },
                // { text: "Housekeeping Report", link: "/housekeeping-report" },
                // { text: "Income / Expense Report", link: "/income-expense-report" },
                // { text: "Extra Service Report", link: "/extra-service-report" },
                // { text: "User Logs", link: "/user-logs" },
                // { text: "Login Details", link: "/login-details" },
            ]
        },
        // {
        //     icon: "fas fa-file-invoice-dollar",
        //     text: "Accounting",
        //     submenu: [
        //         { text: "Requisitions", link: "/requisitions" },
        //         { text: "Purchase Order", link: "/purchase-order" },
        //         { text: "Accounting", link: "/accounting" },
        //         { text: "Daily I/E", link: "/daily-ie" },
        //         { text: "Add Bills", link: "/add-bills" },
        //         { text: "Bill Types", link: "/billl-types" },
        //     ]
        // },
        // {
        //     icon: "fas fa-users-cog",
        //     text: "Staff Mgmt",
        //     submenu: [
        //         { text: "Staff Attendance", link: "/staff-attendance" },
        //         { text: "Staff Details", link: "/staff-details" },
        //         { text: "Staff Category", link: "/staff-category" },
        //     ]
        // },
        // {
        //     icon: "fas fa-warehouse",
        //     text: "Store",
        //     submenu: [
        //         { text: "Outward Register", link: "/outward-register" },
        //         { text: "Inward Register", link: "/inward-register" },
        //         { text: "Store Ledger", link: "/store-ledger" },
        //         { text: "Store Products", link: "/store-products" },
        //     ]
        // },
        // {
        //     icon: "fas fa-sync-alt",
        //     text: "OTA Inventory",
        //     submenu: [
        //         { text: "Room Availability", link: "/room-availability" },
        //         { text: "Rates Updates", link: "/rates-updates" },
        //         { text: "Rooms Rate Plans", link: "/room-rate-plans" },
        //         { text: "Channel Manager Connectivity", link: "/channel-manager-connectivity" },
        //     ]
        // },
        {
            icon: "fas fa-boxes",
            text: "CM Mgmt",
            submenu: [
                { text: "Inventory Updates", link: "/inventory-updates" },
                { text: "Rate Updates", link: "/rate-updates" },
                { text: "OTA Info", link: "/ota-info" },
                { text: "Rooms List", link: "/room-list" },
                { text: "Channel Manager Connectivity", link: "/channel-manager-connectivity" },
            ]
        },
        {
            icon: "fas fa-database",
            text: "Master",
            submenu: [
                { text: "Room Types", link: "/room-types" },
                { text: "Room Info", link: "/room-information" },
                { text: "Rooms Rate Plans", link: "/room-rate-plans" },
                { text: "Rooms Rates", link: "/room-rates" },
                { text: "Property Images", link: "/property-images" },
            ]
        },
        {
            icon: "fas fa-sliders-h",
            text: "Sub Master",
            submenu: [
                { text: "Payment Modes", link: "/payment-modes" },
                { text: "Booking Types", link: "/booking-types" },
                { text: "Extra Services", link: "/extra-services" },
            ]
        },

        propertyMenu,

        // {
        //     icon: "fas fa-bullhorn",
        //     text: "Marketing",
        //     submenu: [
        //         { text: "Marketing", link: "/marketing" },
        //         { text: "Analytics", link: "/analytics" },
        //         { text: "Internal Tools", link: "/internal-tools" },
        //     ]
        // },

        { icon: "fas fa-user-shield", text: "User Logins", link: "/user-logins" },
        { icon: "fas fa-headset", text: "Help & Support", link: "/help-support" },
    ];

    const menuToShow =
        propertyStatus === "Active"
            ? fullMenu
            : [propertyMenu]; // Pending → ONLY property menu


    return (
        <aside
            className="main-sidebar"
            style={{
                background: "linear-gradient(180deg, #2a0845 0%, #6441A5 50%, #2a0845 100%)",
                backgroundImage: "url('/back.jpg')",
                backgroundBlendMode: "overlay",
                backgroundSize: "cover",
                color: "#fff",
                height: "100vh",          // ✅ FIXED HEIGHT
                width: "260px",
                overflow: "hidden",       // ✅ IMPORTANT
                boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                display: "flex",
                flexDirection: "column",
            }}
        >


            {/* TOP PROFILE BAR */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    padding: "15px 10px",
                    position: "sticky",
                    top: 0,
                    background: "rgba(30,0,60,0.8)",
                    backdropFilter: "blur(6px)",
                    zIndex: 10,
                }}
            >
                {propertyLogo ? (
                    <img
                        src={propertyLogo}
                        alt="Property Logo"
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            margin: "0 auto 10px auto",
                            display: "block",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                            background: "#fff"
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "28px",
                            fontWeight: "700",
                            margin: "0 auto 10px auto",
                            color: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
                        }}
                    >
                        {firstLetter}
                    </div>
                )}


                <h5 style={{ fontWeight: "600", margin: 0 }}>{username}</h5>

                {propertyName && (
                    <p style={{
                        fontSize: "13px",
                        margin: "4px 0 0",
                        color: "#e0e0ff",
                        fontWeight: "500"
                    }}>
                        {propertyName}
                    </p>
                )}


                {/* {loading ? (
                    <i
                        className="fas fa-spinner fa-spin"
                        title="Loading"
                        style={{ color: "#ddd", fontSize: "16px" }}
                    />
                ) : propertyStatus === "Pending" ? (
                    <i
                        className="fas fa-file-upload"
                        title="Documents Pending"
                        style={{ color: "yellow", fontSize: "16px" }}
                    />
                ) : (
                    <i
                        className="fas fa-check-circle"
                        title="Active Property"
                        style={{ color: "#4ade80", fontSize: "16px" }}
                    />
                )} */}

            </div>

            {/* MENU AREA */}
            {/* MENU AREA */}
            <div
                className="sidebar-scroll"
                style={{
                    padding: "5px 1px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    flex: 1,                 // ✅ takes remaining height
                    marginBottom: 50
                }}
            >


                {menuToShow.map((item, index) => (
                    <div
                        key={index}
                        className="menu-parent"
                        style={{ position: "relative" }}

                    >

                        <motion.a
                            href={item.link || "#"}
                            style={linkStyle}
                            whileHover={linkHover}
                            onClick={(e) => {
                                if (item.submenu) {
                                    e.preventDefault();
                                    setOpenMenu(openMenu === index ? null : index);
                                }
                            }}
                        >
                            <i className={item.icon} style={iconStyle}></i>
                            <span>{item.text}</span>

                            {item.submenu && (
                                <i
                                    className="fas fa-chevron-right arrow-icon"
                                    style={{
                                        ...arrowIconStyle,
                                        transform: openMenu === index ? "rotate(90deg)" : "rotate(0deg)"
                                    }}
                                ></i>
                            )}
                        </motion.a>


                        {item.submenu && openMenu === index && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    overflow: "hidden",
                                }}
                            >
                                {item.submenu.map((sub, sIndex) => (
                                    <motion.a
                                        key={sIndex}
                                        href={sub.link}
                                        style={{ ...linkStyle, ...submenuStyle }}
                                        whileHover={linkHover}
                                    >
                                        • {sub.text}
                                    </motion.a>
                                ))}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
}

export default Menu;
